import React from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineClock } from "react-icons/hi";
import { SideDrawer } from "../../../atoms/SideDrawer";
import {
  MemberHoursFields,
  MemberHoursFooter,
  useMemberHours,
} from "./MemberHoursForm";

interface MemberSettingsDrawerProps {
  open: boolean;
  onClose: () => void;
  userId: string;
  memberName?: string;
  canEdit: boolean;
}

const MemberSettingsDrawer: React.FC<MemberSettingsDrawerProps> = ({
  open,
  onClose,
  userId,
  memberName,
  canEdit,
}) => {
  const { t } = useTranslation();
  const form = useMemberHours({
    userId,
    open,
    canEdit,
    onSaved: onClose,
    onRemoved: onClose,
  });

  const title =
    memberName && !form.isSelf
      ? (t("agenda.settings.titleFor", { name: memberName }) as string)
      : (t("agenda.settings.title") as string);

  return (
    <SideDrawer
      open={open}
      onClose={onClose}
      title={title}
      icon={HiOutlineClock}
      footer={
        <MemberHoursFooter
          form={form}
          onCancel={onClose}
          personName={memberName}
        />
      }
    >
      <MemberHoursFields form={form} personName={memberName} />
    </SideDrawer>
  );
};

export default MemberSettingsDrawer;
